export interface AsideItem {
  icon: string
  content: string
  link?: string
  linkTarget?: string
  background?: string
  color?: string
}

const AsideItems: AsideItem[] = [
  {
    icon: 'messages-question',
    content: '<b>Zu den FAQ</b>',
    link: '/faq',
    background: 'linear-gradient(90deg, #F93F4D, #FFAF36)',
    color: '#FFFFFF',
  },
  {
    icon: 'envelope',
    content: `
      <b>
        Schreib uns doch mal:
      </b><br>
      <div style="padding-top: 5px">
        Energie<br>
        <a
          style="white-space: nowrap"
          href="mailto:info@stadtwerke-ahrensburg.de"
        >
          <b>info@stadtwerke-ahrensburg.de</b>
        </a>
      </div>
      <div style="padding-top: 5px">
        Glasfaser<br>
        <a
          style="white-space: nowrap"
          href="mailto:glasfaser@stadtwerke-ahrensburg.de"
        >
          <b>glasfaser@stadtwerke-ahrensburg.de</b>
        </a>
      </div>
    `,
  },
  {
    icon: 'phone',
    content: `
      <b style="font-weight: 700">Rufe uns gerne an:</b><br>
      <a
        style="white-space: nowrap"
        href="tel:+49410299740"
      >
        04102 9974-0
      </a>
      <div style="padding-top: 5px">
        <b>Telefonische Erreichbarkeit</b>
        <table>
          <tr>
            <td>
                Mo. - Do.
            </td>
            <td style="padding-left: 20px">
              09:00 - 18:00 Uhr
            </td>
          </tr>
          <tr>
            <td>
                Freitag
            </td>
            <td style="padding-left: 20px">
              09:00 - 15:00 Uhr
            </td>
          </tr>
        </table>
      </div>
    `,
  },
];

export default AsideItems;
